'use strict';

var UserSummaryPanelService = function UserSummaryPanelService(Restangular) {
  function getUserNumbers() {
    return Restangular.one('users').one('summary').get().then(function (data) {
      return data.userSummary;
    });
  }
  return {
    getUserNumbers: getUserNumbers
  };
};
UserSummaryPanelService.$inject = ['Restangular'];
module.exports = UserSummaryPanelService;